import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getImpactList } from '../../../../helpers/normative/backend_helper';

import OSelect from '../../../../Components/OElements/OSelect';
import { getCommuneList, getCompanyList, getEstablishmentList, getRegionList } from '../../../../helpers/establishment/backend_helper';
import OInput from '../../../../Components/OElements/OInput';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { getWaterRightsClassificationList, getWaterRightsStatusList, getWaterRightsTypeList, getWaterRightsUnitList, getWaterRightsUseList, getWaterRightsUseStatusList } from '../../../../helpers/water_rights/backend_helper';
import OHr from '../../../../Components/OElements/OHr';


const WaterRightsForm = ({ dataWaterRights, isEdit, handleToggleModal, isOpen, activeTab, toggleTab }) => {
    const dispatch = useDispatch();
    const [dataActivityTemplateItem, setDataActivityTemplateItem] = useState(null);




    const selectorActivityTemplateItem = createSelector(
        state => state.Activities,
        activitie => ({
            isAddingActivityTemplateItem: activitie.isAdding,
            isAddedActivityTemplateItem: activitie.isAdded,
            isUpdatingActivityTemplateItem: activitie.isUpdating,
            isUpdatedActivityTemplateItem: activitie.isUpdated,
            isLoadingListActivityTemplateItem: activitie.isLoadingList,
            requireCloseModalActivityTemplateItem: activitie.requireCloseModal,
        })
    );

    const { isAddingActivityTemplateItem, isUpdatingActivityTemplateItem, requireCloseModalActivityTemplateItem } = useSelector(selectorActivityTemplateItem);



    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {


        },
        validationSchema: Yup.object({
            name_water_rights: Yup
                .string()
                .required('Campo requerido')
            ,

        }),
        onSubmit: async (values) => {

        },
    });


    const [annualFlowCheck, setAnnualFlowCheck] = useState(false);
    const [ecologicalFlowCheck, setEcologicalFlowCheck] = useState(false);
    const handlerAnnualFlowCheckboxChange = () => { setAnnualFlowCheck(!annualFlowCheck); };
    const handlerEcologicalFlowCheckboxChange = () => { setEcologicalFlowCheck(!ecologicalFlowCheck); };




    const renderFormInputsInfo = () => (
        <>
            <Col lg={3}>
                <OSelect
                    key={`establishment_id`}
                    label='Establecimiento'
                    id='establishment_id'
                    name='establishment_id'
                    isRequired={true}
                    value={dataWaterRights?.establishment?._id || ''}
                    requestApi={() => getEstablishmentList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Región"
                    id="region_id"
                    name="region_id"
                    value={validation.values.region_id || ''}
                    requestApi={() => getRegionList({})}
                    disabled={true}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`commune_id_${validation.values.region_id}`}
                    label="Comuna"
                    id="commune_id"
                    name="commune_id"
                    value={validation.values.commune_id || ''}
                    requestApi={() => getCommuneList({ region_id: validation.values.region_id })}
                    disabled={true}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Empresa"
                    id="company_id"
                    name="company_id"
                    value={validation.values.company_id || ''}
                    requestApi={() => getCompanyList({})}
                    disabled={true}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OInput
                    name='code'
                    label='Código'
                    type='text'
                    validation={validation}
                    isRequired={true}
                    classNameLabel='form-label'
                    classNameInput='form-control'
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Tipo"
                    id="water_rights_type_id"
                    name="water_rights_type_id"
                    isRequired={true}
                    value={validation.values.water_rights_type_id || ''}
                    requestApi={() => getWaterRightsTypeList({})}
                    disabled={false}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Clasificación Por La Naturaleza Del Agua"
                    id="water_classification_id"
                    name="water_classification_id"
                    isRequired={true}
                    value={validation.values.water_classification_id || ''}
                    requestApi={() => getWaterRightsClassificationList({})}
                    disabled={false}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Uso del Agua"
                    id="water_use_id"
                    name="water_use_id"
                    isRequired={true}
                    value={validation.values.water_use_id || ''}
                    requestApi={() => getWaterRightsUseList({})}
                    disabled={false}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Estado del Uso"
                    id="water_use_status_id"
                    name="water_use_status_id"
                    isRequired={true}
                    value={validation.values.water_use_status_id || ''}
                    requestApi={() => getWaterRightsUseStatusList({})}
                    disabled={false}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    label="Estado"
                    id="water_rights_status_id"
                    name="water_rights_status_id"
                    isRequired={true}
                    value={validation.values.water_rights_status_id || ''}
                    requestApi={() => getWaterRightsStatusList({})}
                    disabled={false}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OInput
                    name='number_resolution'
                    label='Número de resolución'
                    type='text'
                    validation={validation}
                    isRequired={true}
                    classNameLabel='form-label'
                    classNameInput='form-control'
                />
            </Col>
            <Col sm={3}>
                <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                    <DatePickerInput
                        label='Fecha de Resolución'
                        id='date_resolution'
                        name='date_resolution'
                        placeholder="Seleccione una fecha"
                        value={validation.values.date_resolution || new Date()} // Valor por defecto
                        onChange={(date) => { validation.setFieldValue("date_resolution", date); }}
                        onBlur={validation.handleBlur}
                        valueFormat='DD-MM-YYYY'
                        error={validation.touched['date_resolution'] && validation.errors['date_resolution'] ? validation.errors['date_resolution'] : ''}
                        clearable={true}
                    />
                </DatesProvider>
            </Col>

            <OHr text={'Información del Caudal'} mt={true} />


            <Col lg={2}>
                <div className="form-check form-switch form-switch-md d-flex flex-column p-0" dir="ltr">
                    <label className="form-check-label" htmlFor="average_annual_flow">
                        ¿Caudal Promedio Anual?
                    </label>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ marginLeft: '10px' }}
                        id="average_annual_flow"
                        name="average_annual_flow"
                        checked={annualFlowCheck}
                        onChange={handlerAnnualFlowCheckboxChange}
                    />
                </div>
            </Col>
            <Col lg={2}>
                <OInput
                    id='average_annual_flow_value'
                    name='average_annual_flow_value'
                    label='Promedio Caudal Anual'
                    type='number'
                    validation={validation}
                    isRequired={true}
                    classNameLabel='form-label'
                    classNameInput='form-control'
                    disabled={!annualFlowCheck}
                />
            </Col>
            <Col lg={2}>
                <OSelect
                    label="Unidad del Caudal"
                    id="average_annual_flow_water_unit_id"
                    name="average_annual_flow_water_unit_id"
                    isRequired={true}
                    value={validation.values.average_annual_flow_water_unit_id || ''}
                    requestApi={() => getWaterRightsUnitList({})}
                    disabled={!annualFlowCheck}
                    validation={validation}
                />
            </Col>


            <Col lg={2}>
                <div className="form-check form-switch form-switch-md d-flex flex-column p-0" dir="ltr">
                    <label className="form-check-label" htmlFor="average_ecological_flow">
                        ¿Caudal Ecológico Promedio?
                    </label>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ marginLeft: '10px' }}
                        id="average_ecological_flow"
                        checked={ecologicalFlowCheck}
                        onChange={handlerEcologicalFlowCheckboxChange}
                    />
                </div>
            </Col>
            <Col lg={2}>
                <OInput
                    id='average_ecological_flow_value'
                    name='average_ecological_flow_value'
                    label='Promedio Caudal Anual'
                    type='number'
                    validation={validation}
                    isRequired={true}
                    classNameLabel='form-label'
                    classNameInput='form-control'
                    disabled={!ecologicalFlowCheck}
                />
            </Col>
            <Col lg={2}>
                <OSelect
                    label="Unidad del Caudal"
                    id="average_ecological_flow_water_unit_id"
                    name="average_ecological_flow_water_unit_id"
                    isRequired={true}
                    value={validation.values.average_ecological_flow_water_unit_id || ''}
                    requestApi={() => getWaterRightsUnitList({})}
                    disabled={!ecologicalFlowCheck}
                    validation={validation}
                />
            </Col>


        </>
    );

    const renderFormInputsControl = () => (
        <>
            <Col lg={6}>
                <Label for='name_activity' className='form-label'>
                    Nombre de la Actividad
                </Label>
                <Input
                    name='name_activity'
                    id='name_activity'
                    className='form-control'
                    placeholder='Ingrese un nombre'
                    type='text'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name_activity || ''}
                    invalid={validation.touched.name_activity && validation.errors.name_activity ? true : false}
                />
                {validation.touched.name_activity && validation.errors.name_activity ? (
                    <FormFeedback type='invalid'>
                        {validation.errors.name_activity}
                    </FormFeedback>
                ) : null}
            </Col>
        </>
    );



    return (
        <React.Fragment>
            <Form
                className='tablelist-form'
                autoComplete='off'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalBody className='modal-body'>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId='1'>
                            <Row className='g-3'>
                                {renderFormInputsInfo()}
                            </Row>
                        </TabPane>
                        <TabPane tabId='2'>
                            <Row className='g-3'>
                                {renderFormInputsControl()}
                            </Row>
                        </TabPane>
                    </TabContent>
                </ModalBody>
                <div className='modal-footer'>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button type='button' onClick={handleToggleModal} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i> Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                            disabled={
                                isAddingActivityTemplateItem ||
                                isUpdatingActivityTemplateItem
                            }
                        >
                            {
                                isAddingActivityTemplateItem ||
                                    isUpdatingActivityTemplateItem
                                    ? (
                                        <i className="label-icon"><Spinner size='sm' /></i>
                                    )
                                    : <i className="ri-save-3-line label-icon"></i>
                            }
                            {isEdit ? 'Editar' : 'Crear'} Derecho de Agua
                        </button>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    );

};

export default WaterRightsForm;
